import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[ctrlShortcuts]",
})
export class ShortcutsDirective {
  @Input("shortcuts") shortcuts: { [key: string]: () => void } = {};

  constructor(private el: ElementRef) {}

  // Add more shortcuts here to be supported
  @HostListener("window:keydown.control.a", ["$event"])
  @HostListener("window:keydown.control.b", ["$event"])
  @HostListener("window:keydown.control.c", ["$event"])
  @HostListener("window:keydown.control.d", ["$event"])
  @HostListener("window:keydown.control.e", ["$event"])
  @HostListener("window:keydown.control.f", ["$event"])
  @HostListener("window:keydown.control.g", ["$event"])
  @HostListener("window:keydown.control.h", ["$event"])
  @HostListener("window:keydown.control.i", ["$event"])
  @HostListener("window:keydown.control.j", ["$event"])
  @HostListener("window:keydown.control.k", ["$event"])
  @HostListener("window:keydown.control.l", ["$event"])
  @HostListener("window:keydown.control.m", ["$event"])
  @HostListener("window:keydown.control.n", ["$event"])
  @HostListener("window:keydown.control.o", ["$event"])
  @HostListener("window:keydown.control.p", ["$event"])
  @HostListener("window:keydown.control.q", ["$event"])
  @HostListener("window:keydown.control.r", ["$event"])
  @HostListener("window:keydown.control.s", ["$event"])
  @HostListener("window:keydown.control.t", ["$event"])
  @HostListener("window:keydown.control.u", ["$event"])
  @HostListener("window:keydown.control.v", ["$event"])
  @HostListener("window:keydown.control.w", ["$event"])
  @HostListener("window:keydown.control.x", ["$event"])
  @HostListener("window:keydown.control.y", ["$event"])
  @HostListener("window:keydown.control.z", ["$event"])
  onKeyDown(event: KeyboardEvent): void {
    const shortcut = this.shortcuts[`Ctrl+${event.key}`];
    if (shortcut) {
      event.preventDefault();
      shortcut();
    }
  }
}
